function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10404",
    transform: "translate(-564 -195)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 5592",
    width: 56,
    height: 56,
    rx: 28,
    transform: "translate(564 195)",
    style: {
      fill: "#f8e6b6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6369"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41159",
    d: "M-590.433 783.085c3.679 0 7.357.008 11.036-.01a.964.964 0 0 1 1.015.617q.988 2.077 2.056 4.115a.625.625 0 0 1-.617.987c-.422-.041-.852.006-1.277-.014-.227-.011-.268.065-.268.277q.011 4.582 0 9.165c0 .678-.161.836-.852.836h-22.259c-.667 0-.835-.165-.835-.822 0-3.044 0-6.089.006-9.133 0-.254-.05-.339-.317-.324-.445.025-.893.012-1.34.006a.568.568 0 0 1-.542-.874c.739-1.5 1.49-2.984 2.234-4.477a.651.651 0 0 1 .67-.35q2.79.006 5.58 0z",
    transform: "translate(1182.425 -561.827)",
    style: {
      fill: "#283045"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41160",
    d: "M-410.976 641.038v-7.615c0-.391.127-.591.419-.675a.551.551 0 0 1 .7.432 2.245 2.245 0 0 1 .016.373v7.386c.117.049.149-.057.2-.107.356-.349.7-.708 1.061-1.055a.571.571 0 0 1 .856-.046.57.57 0 0 1-.046.857q-1.083 1.1-2.182 2.182a.57.57 0 0 1-.923-.014q-1.084-1.076-2.16-2.16a.567.567 0 0 1-.067-.854.576.576 0 0 1 .878.048c.403.392.795.793 1.248 1.248z",
    transform: "translate(1006.936 -424.007)",
    style: {
      fill: "#283045"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41161",
    d: "M-519.282 641c.448-.457.828-.851 1.216-1.239.315-.315.646-.342.9-.085s.225.578-.1.9q-1.044 1.049-2.094 2.094a.592.592 0 0 1-.99.006q-1.062-1.054-2.115-2.116a.581.581 0 0 1-.083-.877c.25-.261.587-.238.9.073.389.387.771.781 1.165 1.181a.494.494 0 0 0 .056-.358v-7.2c0-.485.267-.77.65-.706a.578.578 0 0 1 .487.654v4.519z",
    transform: "translate(1107.26 -423.952)",
    style: {
      fill: "#283045"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41162",
    d: "M-550.159 820.249v11.434c0 .218-.062.278-.278.278q-6.575-.009-13.149 0c-.215 0-.28-.057-.28-.277q.011-4.284 0-8.568c0-.257.1-.278.307-.278 3.822.005 7.644 0 11.467.01a.8.8 0 0 0 .825-.516c.334-.71.7-1.4 1.05-2.106z",
    transform: "translate(1144.986 -595.883)",
    style: {
      fill: "#00a6c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41163",
    d: "M-385.862 819.229c.407.815.775 1.535 1.126 2.265a.7.7 0 0 0 .714.437c1.569-.009 3.138 0 4.707-.009.233 0 .3.059.3.294q-.012 4.271 0 8.542c0 .246-.082.288-.3.287q-3.133-.012-6.266 0c-.2 0-.291-.029-.29-.264q.011-5.674.006-11.347c-.008-.039-.004-.077.003-.205z",
    transform: "translate(981.833 -594.967)",
    style: {
      fill: "#00a6c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41164",
    d: "M-570.971 796.849a.341.341 0 0 1-.073.248c-.49.983-.988 1.963-1.467 2.951a.356.356 0 0 1-.378.23q-6.5-.007-12.99 0c-.3 0-.268-.084-.163-.292q.719-1.413 1.414-2.837a.465.465 0 0 1 .488-.309q6.355.015 12.71.007z",
    transform: "translate(1165.385 -574.446)",
    style: {
      fill: "#84e681"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41165",
    d: "M-381.29 796.872h6.39a.4.4 0 0 1 .423.261q.705 1.453 1.445 2.89c.122.238.084.285-.178.284a895.567 895.567 0 0 0-6.133 0c-.147 0-.268.006-.353-.169-.509-1.042-1.033-2.077-1.551-3.115a1.385 1.385 0 0 1-.043-.151z",
    transform: "translate(977.627 -574.469)",
    style: {
      fill: "#84e681"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41166",
    d: "M-519.19 921.088h-2.618a1.481 1.481 0 0 1-.369-.04.517.517 0 0 1-.411-.552.522.522 0 0 1 .444-.527 1.83 1.83 0 0 1 .371-.031h5.206c.524 0 .807.2.817.563s-.28.59-.821.59z",
    transform: "translate(1107.15 -687.281)",
    style: {
      fill: "#faf871"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewOrder);
export default __webpack_public_path__ + "static/media/NewOrder.3b9a9ca9dbea468ad051ddae5fcec9b5.svg";
export { ForwardRef as ReactComponent };